import React from 'react';
import SelectInputBase from '../base/SelectInputBase';
import { useFormContext, Controller } from 'react-hook-form';
import _ from 'lodash';

interface ISelectInputProps {
    name: string;
    label?: string;
    placeholder?: string;
    options?: { id: string | number; name: string }[];
    idField?: string;
    nameField?: string;
    style?: React.CSSProperties;
    isCreatable?: boolean;
    required?: boolean;
    stateValue?: string | number;
}

const SelectInput: React.FC<ISelectInputProps> = (props) => {
    try {
        const { control, errors } = useFormContext();

        // const defaultValue = control.getValues(props.name);
        // const selectedOption = _.find(props.options, [props.idField || 'id', defaultValue]);

        return (
            <Controller
                // as={SelectInputBase}
                control={control}
                {...props}
                // rules={{ required: props.required ? 'Required Field' : false }}
                render={({ onChange }) => <SelectInputBase {...props} onChange={onChange} error={_.get(errors, props.name)} />}
                // onChange={(value: string | number) => {
                //     console.log('onch value: ', value);
                //     if (value) {
                //         control.setValue(props.name, value);
                //     } else {
                //         control.setValue(props.name, undefined);
                //         control.reRender();
                //     }
                // }}
                // selectedOption={selectedOption}
            />
        );
    } catch {
        return <div>reacthookform/Select must be inside a react-hook-form FormProvider</div>;
    }
};

SelectInput.defaultProps = {
    isCreatable: false,
    required: false,
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/controls/forms/reactHookForm/SelectInput.tsx